<template>
	<div>
		<div class='demo-bg'>
			<el-row>
				<el-col :lg='{span:18,offset:3}' :sm='{span:20,offset:2}' :xs='{span:21,offset:1}'>
					<div style='text-align: center' class="actor">Hello,IT </div>
					<h1 class='demo-title'>IT部门信息管理系统</h1>
					<p class='demo-sub-title' style='margin:20px 0px 30px;'>IT资产管理 ● 合同管理 ● 网络结构管理 ● 供应商管理 ● 账号管理</p>
					
					<div style='padding:20px 0px'>
						<el-button round size='big'  type='success' @click='$router.push("/login")'>我要体验</el-button>
						<el-button round size='big' type='primary' @click='download'>我要下载</el-button>
					</div>
					<div style='margin:20px 0px 0px'>
						很高兴你能看到我做的这个IT部门信息管理系统，希望我做的系统能对你的工作有所帮助。
					</div>
				</el-col>
			</el-row>
		</div>
		<div style='padding:40px 0px;color:#303133'>
			<el-row>
				<el-col :lg='{span:18,offset:3}' :sm='{span:20,offset:2}' :xs='{span:21,offset:1}'>
					<div class='demo-section'>
						<divider class='demo' >**</divider>
						<div class='demo-text'>
							**。
						</div>		
					</div>
					<div class='demo-section'>
						<divider class='demo'>系统介绍</divider>
						<div style='font-size: 18px;font-weight: bold'>**管理</div>
						<div class='demo-text'>
						**。
						</div>
						<div>
							<img src='./img1.jpg' width="100%" />
						</div>
						<div style='font-size: 18px;font-weight: bold'>部门合同、账号、网络结构、供应合作商管理</div>
						<div class='demo-text'>
							**。
						</div>
						<div>
							<img src='./img2.jpg' width="100%" />
						</div>
						<div style='font-size: 18px;font-weight: bold'>系统后台设置</div>
						<div class='demo-text'>
							**。
						</div>
						<div>
							<img src='./img3.jpg' width="100%" />
						</div>
					</div>
					<div class='demo-section'>
						<divider class='demo' >系统部署教程</divider>
						<div class='demo-text'>
							**。
						</div>		
					</div>
					<!-- <div>
					**
					</div> -->
				</el-col>
			</el-row>
		</div>
		<div style='background-color: #101010;color:#9d9d9d; text-align: left;padding:50px 0;'>
			<el-row>
				<el-col :lg='{span:18,offset:3}' :sm='{span:20,offset:2}' :xs='{span:21,offset:1}'>
					<el-row :gutter='10'>
						<el-col :span='14' :xs='{span:24}' style='line-height: 2'>
							如果你对系统有什么建议或者一些更好的想法都可以联系我。
							<br/>
							姓名：**
							<br/>
							邮箱：**@qq.com
							<div style="margin: 40px 0 40px">
								<a href='http://www.miitbeian.gov.cn/' class='c-link' target="_blank">ICP备**</a>
							</div>
						</el-col>
						<el-col :span='10' :xs='{span:24}'>
							<div>
								******！
							</div>
							<div style='margin-top: 15px;text-align: center;'>
								<el-row>
									<el-col :span='12'>
										<!-- <img style='width:120px' src='./wx.jpg'/> -->
										<div>微信**</div>
									</el-col>
									<el-col :span='12'>
										<!-- <img style='width:120px' src='./zfb.jpg'/> -->
										<div>支付宝**</div>
									</el-col>
								</el-row>
								
								
							</div>
						</el-col>
					</el-row>
				</el-col>
			</el-row>
		</div>		 
	</div>
</template>
<script>
	export default{
		data(){
			return {}
		},
		methods:{
			download(){
				this.$message.success('**...')
			}
		}
	}
</script>
<style lang='less'>
	.demo-bg {
		position: relative;
		padding: 130px 0px 80px;
		color: #fff;
	 	text-align: center;
		text-shadow: 0 1px 3px rgba(0,0,0,.4),0 0 30px rgba(0,0,0,.075);
		background: #020031;
		background: -moz-linear-gradient(45deg,#020031 0,#6d3353 100%);
		background: -webkit-gradient(linear,left bottom,right top,color-stop(0%,#020031),color-stop(100%,#6d3353));
		background: -webkit-linear-gradient(45deg,#020031 0,#6d3353 100%);
		background: -o-linear-gradient(45deg,#020031 0,#6d3353 100%);
		background: -ms-linear-gradient(45deg,#020031 0,#6d3353 100%);
		background: linear-gradient(45deg,#020031 0,#6d3353 100%);
		filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#020031', endColorstr='#6d3353', GradientType=1);
		-webkit-box-shadow: inset 0 3px 7px rgba(0,0,0,.2),inset 0 -3px 7px rgba(0,0,0,.2);
		-moz-box-shadow: inset 0 3px 7px rgba(0,0,0,.2),inset 0 -3px 7px rgba(0,0,0,.2);
		box-shadow: inset 0 3px 7px rgba(0,0,0,.2),inset 0 -3px 7px rgba(0,0,0,.2);
		.demo .title{
			font-size:25px !important;
			margin-top: -15px !important;
		}
	}
	.demo-title{
			font-size:62px;
			margin-bottom: 0px;
		}
	.actor{
		font-size: 80px;
		min-height:65px;
	}
	.actor:after{
		content:"";
		width:6px;	
		height:70px;
		vertical-align:-5px;
		margin-left:5px;
		background-color:#fff;
		display:inline-block;
		animation:blink .4s infinite alternate;
		-webkit-animation:blink .4s infinite alternate;
	}
	.banner-desc{padding-top:110px;padding-left:30px;font-size:46px;position:relative;z-index:10}
	.banner-desc h2{font-size:72px;margin:0;color:#fff}
	.banner-desc p{font-size:14px;opacity:.8;width:420px;line-height:1.8;padding-left:3px}
	@keyframes blink{0%{opacity:0}to{opacity:1}}
	
	.demo-text{
		padding:15px 0;
		text-indent:2em;
		line-height: 2;
		div{
			margin-bottom: 10px
		}
	}
	.demo-section{
		padding:30px 0;
	}
	@media (max-width:768px){
		.demo-bg{
			.demo-title{
				font-size:42px;
			}
			.actor{
				font-size: 60px;
				min-height:65px;
			}
			.actor:after{
				width:6px;	
				height:55px;
				vertical-align:-5px;
			}
			.demo-sub-title{
				
			}
		}
		
	}
</style>